
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { ExportReceiptModel, SummaryExportReceiptModel } from '@/models/export-receipt';

import ListReceipt from './components/ListReceipt.vue';
import FilterBox from './components/FilterBox.vue';

import authService from '@/services/auth-services';
import exportReceiptServices from '@/services/export-receipt-services';
@Component({
    components: {
        ListReceipt,
        FilterBox,
        Loading,
        Paging,
    }
})
export default class ListItem extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private summaryOrder: SummaryExportReceiptModel = new SummaryExportReceiptModel();
    private listItem: ExportReceiptModel[] = [];
    private isLoading = false;
    private isShowModal = false;
    private customerInfo: any = {};

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    private async created() {
        await this.getCustomersInfo();
        this.loadData();
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryExportReceiptModel();
        const result = await exportReceiptServices.getList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpList: ExportReceiptModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus2: result.data.summary.TotalStatus2 || 0,
                TotalStatus3: result.data.summary.TotalStatus3 || 0
            };

            for (const item of result.data.data) {
                const model = new ExportReceiptModel();
                model.ID = item.ID;
                model.UID = item.UID;
                model.Username = item.Username;
                model.Status = item.Status;
                model.StatusDetail = DATA.receiptStatus.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };
                model.ExchangeRate = item.ExchangeRate;
                model.Weight = item.Weight;
                model.Volume = item.Volume;
                model.NumberOfPack = item.NumberOfPack;
                model.FeeShip = item.FeeShip;
                model.FeeShipVND = item.FeeShipVND;
                model.FeeType = item.FeeType;
                model.Price = item.Price;
                model.Amount = item.Amount;
                model.PaymentMethod = item.PaymentMethod;
                model.PaymentDate = item.PaymentDate;
                model.ExportDate = item.ExportDate;
                model.CreatedDate = item.CreatedDate;
                
                tmpList.push(model);
            }
            this.listItem = tmpList;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }
}
